import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import { cn } from "../../../util/classNameConstructor";
import Button from "../../core/button/Button";
import Icon from "../../core/icon/Icon";

const DrawingUiElements = ({
  mapType,
  statefulMap,
  bottom,
  continueFeat,
  featureId,
  handleDelete,
  handleSaveAll,
  handleContinueDrawingFromLastVertex,
  handleSetAddDescription,
  setContinueFeat,
  setOpenDescription,
  openDescription,
  descriptionProvided,
  showMessage
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <>

    {showMessage && !openDescription && <div className={cn('flex justify-center z-[9999]', isMobile ? 'fixed left-0 w-screen bottom-24' : 'absolute left-1/2 -translate-x-1/2 w-max bottom-[calc(100vh-130px)] max-w-[400px]') }>
      <div className={cn(
            "w-full h-auto flex  pointer-events-all rounded-3xl gap-2.5 p-5 bg-surface-default shadow-lg border border-border-default z-[999999999] transition-colors duration-200 mx-3"
          )}>
<Icon name="alert" className=" text-icon-critical shrink-0" />
            <span>{t(`map:drawInfoTooltip.maxFeaturesReached.${mapType.drawType}`)}</span>
            </div>
            </div>
            }
      <div 
        className={
           cn('flex justify-center z-[1]', isMobile ? 'fixed left-0 w-screen' : 'absolute left-1/2 -translate-x-1/2 w-max')
         
        }
        style={{ bottom }}
      >
       
        {featureId && (
          <div className={cn(
            "w-full h-auto flex flex-col pointer-events-all md:rounded-3xl gap-2.5 p-5 bg-surface-default shadow-lg border border-border-default z-[999999999] transition-colors duration-200",
          )}>
            <div 
              className={cn(
                'flex gap-2',
                isMobile ? 'ml-[50px] w-[calc(100%-50px)]' : 'w-full'
              )}
            >
              <div className="w-full flex justify-end">
                <Button
                  size="lg"
                  text={
                    t("util:delete", {
                      val: t(
                        `global:${
                          mapType.drawType === "point"
                            ? "point"
                            : mapType.drawType === "path"
                            ? "path" 
                            : "area"
                        }`
                      )
                    })
                  }
                  width="max"
                  onClick={() => {
                    handleDelete(featureId);
                  }}
                />
              </div>
              {continueFeat &&
                statefulMap.df?.getMode() !== "custom_draw_line_string" && (
                  <Button
                  className="whitespace-nowrap"
                    size="lg"
                    dataCy="drawingFeatureContinue"
                    onClick={() => {
                      handleContinueDrawingFromLastVertex(
                        statefulMap.df,
                        continueFeat,
                        setOpenDescription
                      );
                      setContinueFeat(false);
                    }}
                    text={t("map:draw.continueDrawing")}
                  />
                )}
              <Button
                variant="primary"
                leadingIcon="checkmark-md"
                text={isMobile && continueFeat ? "" : t("global:save")}
                size="lg"
                disabled={openDescription === true && !descriptionProvided}
                disabledNotice={t("map:drawInfoTooltip.descriptionMissing")}
                dataCy="drawingFeatureSave"
                onClick={() => {
                  handleSetAddDescription(featureId, "save");
                  handleSaveAll(featureId);
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DrawingUiElements;
